import { WatchfaceDeviceType } from '@/hooks';
import { getImageArrayIndexs } from '@/hooks/use-image-array';
import { Shape, ShapeType } from '@/services/shape';
import { canUse } from '@/utils/can-use.utils';
import { getWeatherAstIndexs } from './weather.utils';

export const getImageArrayAstLen = (
  shape: Shape,
  deviceType: WatchfaceDeviceType,
  weatherWhole?: boolean
) => {
  // 是否是天气
  const isWeather = !!shape.sourceItem?.weatherValueRange;
  const isChineseTime = shape.sourceItem?.key == 'timeChineseTime';
  // 是否指南针
  const isCompass = shape.sourceItem?.key == 'systemSensorCompassDirection';
  if (isWeather) {
    return (
      getWeatherAstIndexs({
        type: shape.attrs.sourceWeatherType ?? 'whole',
        deviceType,
        fullWeatherCode: weatherWhole
      })?.length ?? 1
    );
  } else if (isChineseTime) {
    return (shape.sourceItem.labelRange?.length ?? 0) + 1;
  } else {
    const len = getImageArrayIndexs(shape, deviceType)?.length ?? 1;
    return isCompass ? len + 1 : len;
  }
};

export const supportTemperatureType = (
  shapeType: ShapeType,
  sourceKey: string
) => {
  return (
    [ShapeType.ImageArray, ShapeType.ProgressBar].includes(shapeType ?? '') &&
    sourceKey?.endsWith('_temp')
  );
};

export const supportFahrenheit = (
  deviceType: WatchfaceDeviceType,
  sourceKey: string
) => {
  return (
    canUse('temperature-fahrenheit', deviceType).valid &&
    // ['N65', 'M67']设备在weatherCurrentTempature_temp时不支持华氏度
    !(
      ['N65', 'M67'].includes(deviceType) &&
      sourceKey == 'weatherCurrentTempature_temp'
    )
  );
};
